<template>
  <div>
    <v-row class="mb-12 mx-0">
      <v-flex class="md12 sm12 xs12 user-column">
        <div class="avatar-and-name">
          <div>
            <div
              class="camera-icon"
              @click="toggleCropperModal"
            >
              <v-icon
                :color="'#FFF'"
                :size="26"
              >
                $snCamera
              </v-icon>
            </div>
            <sn-avatar
              class="mr-4"
              size="xl"
              :image="user.profilePictureUrl"
              :initials="initials"
            />
          </div>
          <div class="name-updated">
            <h2
              class="sn-h3"
              data-cy="profile-info-title"
            >
              User Info
            </h2>
            <div class="sn-body-1 user-updated-at">
              Last updated {{ user.formattedUpdatedAt }}
            </div>
          </div>
        </div>
      </v-flex>
    </v-row>
    <photo-uploader
      :value="uploaderVisible"
      :on-save="updateProfilePicture"
      @image="handleImageChange"
      @close="toggleCropperModal"
    />
  </div>
</template>

<script>
import photoUploader from './photoUploader'

export default {
  name: 'MyProfileHeader',
  components: {
    photoUploader
  },
  props: {
    user: {
      type: Object,
      default: null,
      required: true
    }
  },
  data () {
    return {
      uploaderVisible: false,
      newProfilePicture: {
        filename: '',
        image: null,
        data: null
      }
    }
  },
  computed: {
    initials () {
      return `${this.user.firstName[0] || ''}${this.user.lastName[0] || ''}`
    }
  },
  methods: {
    toggleCropperModal () {
      this.uploaderVisible = !this.uploaderVisible
    },
    updateProfilePicture () {
      this.$emit('update-profile-picture', this.newProfilePicture.data, this.newProfilePicture.filename)
    },
    handleImageChange ({ filename, dataURL }) {
      this.newProfilePicture.filename = filename
      this.newProfilePicture.image = dataURL
      this.newProfilePicture.data = dataURL.split(',', 2)[1]
    }
  }
}
</script>

<style scoped lang="scss">
@import '~/assets/css/snui/index';

.avatar-and-name {
  display: flex;
  position: relative;

  .camera-icon {
    display: flex;
    position: absolute;
    align-items: center;
    justify-content: center;
    background-color: #1f1f1fCC;
    border-radius: 50%;
    border: 2px solid white;
    color: white;
    height: 40px;
    width: 40px;
    left: 72px;
    top: 72px;
    cursor: pointer;
    z-index: 1;
  }

  .name-updated {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .user-updated-at {
      color: $sn-primary-01;
    }

    p {
      margin: 0 0 8px 0;
    }
  }
}

.illustration-container {
  background-color: $sn-brand-01;
  width: 104px;
  height: 104px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
